module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n\n<app-header></app-header>\n\n<section id=\"main\" style=\"background-image:url('../../../assets/img/bg.jpg');\" >\n  <app-sidebar></app-sidebar>\n  <section id=\"content\">\n    <router-outlet></router-outlet>\n  </section>\n</section>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.html
// module id = ./src/app/components/app/app.component.html
// module chunks = main